import {
  BLOCKS,
  MARKS,
  type Document,
  type TopLevelBlock
} from '@contentful/rich-text-types';

function paragraph(
  text: string,
  marks: { type: string }[] = []
): TopLevelBlock {
  return {
    nodeType: BLOCKS.PARAGRAPH,
    data: {},
    content: [
      {
        nodeType: 'text' as const,
        value: text,
        marks,
        data: {}
      }
    ]
  };
}

export const PRODUCT_FINDER_ERROR_FALLBACK_DOCUMENT: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    paragraph('No match found for your parameters.', [{ type: MARKS.BOLD }]),
    paragraph(
      'Try adjusting your values, or reach out to our Sales Team for a custom recommendation.'
    )
  ]
};

export const CUSTOMER_ACCOUNT_TICKETS_EMPTY_FALLBACK_DOCUMENT: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    paragraph('Keine Tickets vorhanden', [{ type: MARKS.BOLD }]),
    paragraph(
      'Derzeit liegen keine Support-Tickets vor. Erstellen Sie ein neues Ticket, um uns Ihr Anliegen mitzuteilen.'
    )
  ]
};

export const PDP_HINT_DISCONTINUED_FALLBACK_DOCUMENT: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    paragraph(
      'Hint: This product is no longer on sale. This page is archived.',
      [{ type: MARKS.BOLD }]
    )
  ]
};

export const PDP_HINT_PENDING_DISCONTINUATION_FALLBACK_DOCUMENT: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    paragraph('Hint: Upcoming discontinuation.', [{ type: MARKS.BOLD }])
  ]
};
